/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Bc_Record_Match_InvalidInputs */

const en_error_bc_record_match_invalid = /** @type {(inputs: Error_Bc_Record_Match_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The record of Business Central cannot be matched to this organization:`)
};

/**
* | output |
* | --- |
* | "The record of Business Central cannot be matched to this organization:" |
*
* @param {Error_Bc_Record_Match_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_bc_record_match_invalid = /** @type {((inputs?: Error_Bc_Record_Match_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Bc_Record_Match_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_bc_record_match_invalid(inputs)
});